import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { stringify } from 'query-string';
import { number, string, shape, func, oneOfType } from 'prop-types';
import { STATIC_PATH } from '../../config';
import { LocalStorage } from '../../utils/utils';

const propTypes = {
  appId: oneOfType([string, number]).isRequired,
  provider: string.isRequired,
  title: string.isRequired,
  onUnsubscribe: func.isRequired,
  account: shape({
    id: number.isRequired,
    name: string,
    provider: string,
    external_id: string,
  }),
};

const makeSubscribeUrl = (appId, payload) => {
  const { origin, pathname } = window.location;
  const redirect_uri = `${origin}${pathname}`;
  const state = JSON.stringify({ ...payload });
  let params = {};

  switch (payload.provider) {
    case 'google':
      params = stringify({
        client_id: appId,
        response_type: 'token',
        scope: 'email openid profile',
        redirect_uri,
        state,
      });

      return `https://accounts.google.com/o/oauth2/auth?${params}`;

    case 'facebook':
      params = stringify({
        client_id: appId,
        response_type: 'token',
        redirect_uri,
        scope: 'email',
        state,
      });

      return `https://www.facebook.com/v3.1/dialog/oauth?${params}`;

    case 'vk':
      params = stringify({
        client_id: appId,
        display: 'page',
        redirect_uri,
        response_type: 'code',
        scope: 'email',
        v: '5.85',
        state,
      });

      return `https://oauth.vk.com/authorize?${params}`;
  }
};

const SocialsListItem = ({ account, appId, provider, title, onUnsubscribe }) => {
  const [security_hash] = useState(Math.random());

  return (
    <div className="socials-list-item">
      <div className="socials-list-item-desc">
        <span className="socials-list-item-icon">
          <img src={`${STATIC_PATH}/img/socials/${provider}.svg`} alt={provider} />
        </span>

        <span className="socials-list-item-info">
          <span className="socials-list-item-title">{title}</span>

          {account ? (
            <span className="socials-list-item-name">{account.name}</span>
          ) : (
            <a
              onClick={() => LocalStorage.set('security_hash', security_hash)}
              href={makeSubscribeUrl(appId, { provider, security_hash })}
            >
              <FormattedMessage id="socials.connect" defaultMessage="Connect" />
            </a>
          )}
        </span>
      </div>

      <div className="socials-list-item-controls">
        {account && (
          <Button type="button" size="sm" color="light" className="form-group-btn" onClick={() => onUnsubscribe(account.id)}>
            <FormattedMessage id="socials.disconnect" defaultMessage="Disconnect" />
          </Button>
        )}
      </div>
    </div>
  );
};

SocialsListItem.propTypes = propTypes;

export default SocialsListItem;
